import { DatePicker } from "antd";
import { ErrorType } from "../../../types/common-type";
import dayjs from "dayjs";
import ErrorMessage from "../ErrorMessage";
import "./formfield.css";

interface InputProps<T extends Record<string, any>> {
  label: string;
  name: keyof T;
  data: T;
  onChange: (name: keyof T, value: string) => void;
  required?: boolean;
  errors?: ErrorType | null;
  disabled?: boolean;
  colClass?: string;
}

export const InputDateField = <T extends Record<string, any>>({
  label,
  name = "",
  data,
  onChange,
  required = false,
  errors = {},
  disabled = false,
  colClass,
}: InputProps<T>) => {
  const hasError = errors ? !!errors[name as string] : false;

  const handleChange = (_: dayjs.Dayjs | null, ds: string | string[]) => {
    const dateStr = Array.isArray(ds) ? ds[0] : ds;

    if (!dateStr) {
      onChange(name, "");
      return;
    }

    const [day, month, year] = dateStr.split("-");
    if (day && month && year) {
      onChange(name, `${year}-${month}-${day}`);
    }
  };

  const picker = (
    <div>
      <label className="form-label formfield-label">
        {label} {required && <span className="text-danger">*</span>}
      </label>
      <DatePicker
        className={`form-control form-control-sm formfield-control datetimepicker w-100 ${
          hasError ? "is-invalid border-danger" : ""
        }`.trim()}
        format={{ format: "DD-MM-YYYY", type: "mask" }}
        placeholder="DD-MM-YYYY"
        value={data[name] ? dayjs(data[name], "YYYY-MM-DD") : null}
        onChange={handleChange}
        disabled={disabled}
      />
      {hasError && errors && (
        <ErrorMessage message={errors?.[name as string]} />
      )}
    </div>
  );

  return colClass ? <div className={colClass}>{picker}</div> : picker;
};


// import { DatePicker } from "antd";
// import { ErrorType } from "../../../types/common-type";
// import dayjs from "dayjs";
// import ErrorMessage from "../ErrorMessage";

// interface InputProps<T extends Record<string, any>> {
//   label: string;
//   name: keyof T;
//   data: T;
//   onChange: (name: keyof T, value: string) => void;
//   required?: boolean;
//   errors?: ErrorType | null;
//   disabled?: boolean;
//   colClass?: string;
// }

// export const InputDateField = <T extends Record<string, any>>({
//   label,
//   name = "",
//   data,
//   onChange,
//   required = false,
//   errors = {},
//   disabled = false,
//   colClass,
// }: InputProps<T>) => {
//   //   const hasError = errorKey ? !!errors[errorKey] : false;
//   const hasError = errors ? !!errors[name as string] : false;

//   const handleChange = (_: dayjs.Dayjs | null, ds: string | string[]) => {
//     const dateStr = Array.isArray(ds) ? ds[0] : ds;

//     if (!dateStr) {
//       onChange(name, "");
//       return;
//     }

//     const [day, month, year] = dateStr.split("-");
//     if (day && month && year) {
//       onChange(name, `${year}-${month}-${day}`);
//     }
//   };

//   const picker = (
//     <div>
//       <label className="form-label fw-semibold" style={{ fontSize: "0.82rem" }}>
//         {label} {required && <span className="text-danger">*</span>}
//       </label>
//       <DatePicker
//         // ${hasError ? "is-invalid border-danger" : ""}
//         className={`form-control form-control-sm border datetimepicker w-100 `}
//         format={{ format: "DD-MM-YYYY", type: "mask" }}
//         placeholder="DD-MM-YYYY"
//         value={data[name] ? dayjs(data[name], "YYYY-MM-DD") : null}
//         onChange={handleChange}
//         disabled={disabled}
//         // disabledDate={(current) => current && current > dayjs().endOf("day")}
//       />
//       {hasError && errors && (
//         <ErrorMessage message={errors?.[name as string]} />
//       )}
//     </div>
//   );

//   return colClass ? <div className={colClass}>{picker}</div> : picker;
// };
